/** Role RBAC (§5.3) — klucze kanoniczne (tabela user_roles). */

export const ROLES = ['hr_admin', 'payroll', 'manager', 'employee'] as const

export type Role = (typeof ROLES)[number]

export function isRole(value: unknown): value is Role {
  return typeof value === 'string' && (ROLES as readonly string[]).includes(value)
}
